import React from "react";
import { LegalLayout } from "./LegalLayout";

const H = ({ children }) => (
  <h2 className="text-lg font-bold tracking-tight pt-2">{children}</h2>
);

export default function Terms() {
  return (
    <LegalLayout title="Terms of Use" updated="23 September 2026">
      <p>
        Welcome to NUMEX, a free browser-based daily number puzzle. By playing NUMEX you agree to
        these terms. If you do not agree, please do not use the service.
      </p>

      <H>Permitted use</H>
      <p>
        NUMEX is provided for your personal, non-commercial enjoyment. You may play the daily puzzle
        and share your spoiler-free result. Please play fairly.
      </p>

      <H>Acceptable behaviour</H>
      <p>
        You agree not to misuse the service, including: attempting to access or extract unpublished
        or future puzzle answers, interfering with or overloading our systems, using automated
        scripts or bots to play or scrape, attempting to gain unauthorised access to the admin area
        or any non-public endpoint, or circumventing the game&apos;s rules or security.
      </p>

      <H>Intellectual property</H>
      <p>
        The NUMEX name, logo, puzzles, and the design and content of the site are owned by NUMEX and
        protected by applicable laws. You may not copy, redistribute, or create derivative
        commercial products from them without permission.
      </p>

      <H>Service availability &amp; changes</H>
      <p>
        NUMEX is offered on an &quot;as is&quot; and &quot;as available&quot; basis. We may update,
        change, suspend, or discontinue any part of the game at any time, and a new puzzle is
        published each day. We do not guarantee uninterrupted or error-free availability.
      </p>

      <H>Disclaimers &amp; limitation of liability</H>
      <p>
        To the maximum extent permitted by law, NUMEX is provided without warranties of any kind and
        we are not liable for any indirect or incidental damages arising from your use of, or
        inability to use, the game.
      </p>

      <H>Changes to these terms</H>
      <p>
        We may revise these terms from time to time. Continued use of NUMEX after changes take
        effect constitutes acceptance of the updated terms.
      </p>

      <H>Contact</H>
      <p>
        Questions about these terms? Email{" "}
        <a className="underline" href="mailto:hello@playnumex.com">hello@playnumex.com</a>.
      </p>
    </LegalLayout>
  );
}
